import lazyLoadView from "@router-utils/lazyload-view";
import routeError from "@router-utils/route-error";
import store from '@store'

export default [
  // ===
  // 購買包套方案
  // ===
  {
    path: '/prepaid',
    name: 'prepaid',
    component: () => lazyLoadView(import('@views/Prepaid/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        // if(!store.state.merchant.currentMerchant?.prepaidSetting?.isEnabled) {
        //     next({ name: '404' })
        //   }
        if (!store.state.merchant.currentMerchant?.prepaidSetting?.isEnabled)
          next({ name: '404' })

        try {

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      liffShowMenu: false
    },
  },
  // ===
  // 購買包套方案 內容頁
  // ===
  {
    path: '/prepaid/:prepaidAlias',
    name: 'prepaid-item',
    component: () => lazyLoadView(import('@views/Prepaid/Item')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          // if (!store.state.merchant.currentMerchant?.prepaidSetting?.isEnabled)
          // next({ name: '404' })
          const [
            currentPrepaidItem
          ] = await Promise.all([
            store.dispatch('merchant/fetchPrepaidItem', {
              prepaidAlias: routeTo.params.prepaidAlias,
            }),
          ]);

          routeTo.params.prepaidItem = currentPrepaidItem.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      liffShowMenu: false
    },
    props: (route) => ({
      prepaidItem: route.params.prepaidItem || {}
    }),
  },
]
